<template>
    <div class="iv-toast" v-show="toastShow">
        {{ toastText }}
    </div>
</template>
<script>
    export default{
        name: 'toast',
        data(){
            return{
                // toastShow:false,
                // toastText:'',
            }
        },
        methods:{
            // showToast (str) {
            //     let that = this
            //     that.toastText = str
            //     that.toastShow = true
            //     setTimeout(function(){
            //         that.toastShow = false
            //     }, 1500);
            // }
        }
    }
</script>
<style lang="less" scoped>
    .iv-toast {
        position: fixed;
        z-index: 2000;
        left: 50%;
        top:40%;
        transition:all .5s;
        -webkit-transform: translateX(-50%) translateY(-50%);
        -moz-transform: translateX(-50%) translateY(-50%);
        -ms-transform: translateX(-50%) translateY(-50%);
        -o-transform: translateX(-50%) translateY(-50%);
        transform: translateX(-50%) translateY(-50%);
        text-align: center;
        border-radius: 5px;
        color:#FFF;
        font-size:16px;
        background: rgba(0, 0, 0, 0.8);
        height: 45px;
        line-height: 45px;
        padding: 0 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/toast/toast.vue